import {useEffect,useState,useSyncExternalStore} from 'react';
import {api} from '../api';
import {createMemorySettings,type MemorySettingsController,type MemorySettingsState} from '../memory-settings';

export interface MemorySettings extends MemorySettingsState {controller:MemorySettingsController}
export function useMemorySettings(active=true):MemorySettings{
 const [controller]=useState(()=>createMemorySettings({read:api.memory,setEnabled:api.setMemoryEnabled,reset:api.resetMemory}));
 const state=useSyncExternalStore(controller.subscribe,controller.getSnapshot,controller.getSnapshot);
 useEffect(()=>{if(!active)return;controller.activate();return controller.deactivate;},[active,controller]);
 return {...state,controller};
}
